import { Component, Input } from '@angular/core';
import { FormComponentLookup, FormConfig, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { PtlWindowLocationService } from '@ptl/global-components';
import { ZIP_COUNTY_STATE_NAME } from '../../../demographics/zip-county-modal/reducers/zipCounty.reducer';
import { ProducerStateStructure } from '../../../producer/configs/interfaces/producerStateStructure.interface';
import { PRODUCER_STATE_NAME } from '../../../producer/configs/reducers/producer.reducer';
import { ZipCountyStateStructure } from '../../../shared/interfaces/zipCountyStateStructure.interface';
import { ReducerUtilityService } from '../../../../shared/utility-services/reducer-utility.service';
import { EnrollmentAppStateStructure } from '../../../shared/interfaces/enrollmentAppStateStructure.interface';
import { ENROLLMENT_APP_STATE_NAME } from '../../../../shared/reducers/enrollmentApp.reducer';
import { PlanUtilityService } from '../../../plan-selection/plan-summary-list/plan-utility.service';
import { PlanAttributes, SummaryView } from '../../../plan-selection/interfaces/plan-attributes.interface';
import { Product } from '../../../plan-selection/interfaces/product.interface';

@FormComponentLookup('page-dsnp-enrollment')
@Component({
    selector: 'app-page-dsnp-enrollment',
    templateUrl: './page-dsnp-enrollment.component.html',
    styleUrls: ['./page-dsnp-enrollment.component.scss'],
    standalone: false
})
export class PageDsnpEnrollmentComponent extends FormPageComponentClass<FormNavigationConfig> {
  
  isLoading: boolean = false;
  errorMsg: string = null;

  constructor(
    private windowLocationService: PtlWindowLocationService,
    private reducer: ReducerUtilityService,
    private planUtilityService: PlanUtilityService
  ) {
    super();
  }

  ngOnInit() {
    this.initPageConfig();
  }

  // Save the app to generate an App ID, then build the URL to the Cavulus page and navigate to it
  submitHook(): Promise<any> {
    this.isLoading = true;
    this.errorMsg = null;

    return new Promise((resolve, reject) => {
      this.saveForLaterButtonHook(this.formConfig).then(() => {
        // make sure the app saved before building the URL
        const enrollState: EnrollmentAppStateStructure = this.reducer.getState(ENROLLMENT_APP_STATE_NAME);
        if (enrollState.appId) {
          this.navigateToEnroll();
          return;
        }

        // reset form values if save didn't work
        this.isLoading = false;
        this.errorMsg = 'There was a problem enrolling you. Please try again later.';
        resolve(true);
      });
    });
  }

  navigateToEnroll() {
    const enrollState: EnrollmentAppStateStructure = this.reducer.getState(ENROLLMENT_APP_STATE_NAME);
    const zipcountyState: ZipCountyStateStructure = this.reducer.getState(ZIP_COUNTY_STATE_NAME);
    const producerInfo: ProducerStateStructure = this.reducer.getState(PRODUCER_STATE_NAME);
    const selectedPlan: Product<PlanAttributes, SummaryView> = this.planUtilityService.getSelectedPlan();
    const enrollmentType = this.reducer.getStateFromPath(this.reducer.getPayloadStates(), this.formConfig.form.customConfigs.enrollmentTypeStatePath);
    const baseUrl = enrollmentType.baseUrl.replace('<<planyear>>', selectedPlan.year);
    let queryParams = [];

    queryParams.push('form_data[CampaignIdentifier]=' + selectedPlan.attributes.CAMPAIGN_IDENTIFIER);
    queryParams.push('[AgentNationalID]=' + producerInfo.selectedAgency.npnNo);
    queryParams.push('[UniqueID]=' + enrollState.appId);
    queryParams.push('[ApplicantZip]=' + zipcountyState.zipCode);
    queryParams.push('[ApplicantCounty]=' + this.toTitleCase(zipcountyState.county.county));
    queryParams.push('[ApplicantState]=' + zipcountyState.county.state);
    queryParams.push('[PlanYear]=' + selectedPlan.year);
    queryParams.push('[Description]=' + selectedPlan.attributes.PRODUCT_NAME);
    queryParams.push('[ProductID]=' + selectedPlan.attributes.VENDOR_PRODUCT_ID);

    let finalUrl = `${baseUrl}?&${queryParams.join('&')}`;
    window.open(finalUrl, '_blank');

    // redirect after enrollment page opens
    this.windowLocationService.goToUrl(this.formConfig.form.customConfigs.postEnrollRedirect);
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
  }
}
